import React from "react";
import { useRouteError, isRouteErrorResponse, Link } from "react-router-dom";
import styles from "./errorBoundary.module.scss";

const ErrorBoundary = () => {
  const error = useRouteError();

  if (isRouteErrorResponse(error)) {
    if (error.status === 404) {
      return (
        <div className={styles.errorContainer}>
          <h1>404 - Page non trouvée</h1>
          <p>Désolé, la page que vous recherchez n'existe pas.</p>
          <Link to="/" className={styles.homeLink}>
            Retour à l'accueil
          </Link>
        </div>
      );
    }
  }

  return (
    <div className={styles.errorContainer}>
      <h1>Oups ! Une erreur est survenue</h1>
      <p>Désolé, quelque chose s'est mal passé.</p>
      <Link to="/" className={styles.homeLink}>
        Retour à l'accueil
      </Link>
    </div>
  );
};

export default ErrorBoundary;
